import React from "react";


class DiagramPath extends React.Component {

    state = {
        // points: { start: [0, 0], end: [200, 100] }
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.mouseDown)
    }

    mouseHover = (e, isClick) => {
        if (!this.props.isActivePath && !this.props.disablePathHover) {
            this.setState({ hovered: true })
            window.addEventListener('mousedown', this.mouseDown)
        }
    }

    mouseLeave = (e) => {
        // console.log("Leave")
        // console.log(e)
        this.setState({ hovered: false })

    }

    // mouseButHover = (e, isClick) => {
    //     // console.log("HERE")
    //     this.setState({ hovered: true })
    // }

    // mouseButLeave = (e) => {
    //     this.setState({ hovered: false })

    // }


    mouseDown = () => {
        window.removeEventListener('mousedown', this.mouseDown)
        this.setState({ hovered: false, showDrop: false })
        // console.log(this.props.data)
    }

    removePath = () => {
        // console.log('remve', this.props.data)
        window.removeEventListener('mousedown', this.mouseDown)
        if (this.props.removePath) {
            this.props.removePath(this.props.data.key ?? this.props.data.id)
        }
    }


    onDragEnter = (e) => {
        if (this.props.hasDropEffect) {
            this.setState({ hovered: true, showDrop: true })
        }

    }

    onDragLeave = (e) => {
        if (this.props.hasDropEffect) {
            this.setState({ hovered: false, showDrop: false })
        }
    }

    onDragOver = (e) => {
        e.preventDefault()
    }

    onDrop = (e) => {
        e.stopPropagation()
        this.setState({ showDrop: false })

        if (this.props.onDrop) {
            this.props.onDrop(this.props.data)
        }
    }





    render() {
        let data = this.props.data
        let points = {}


        points.start = [Number(data.start[0]) + Number(data.startOffset[0]), Number(data.start[1]) + Number(data.startOffset[1])]
        points.end = [Number(data.end[0]) + Number(data.endOffset[0]), Number(data.end[1]) + Number(data.endOffset[1])]

        // let data = prop.data
        let width = (points.end[0] - points.start[0]) ?? 0
        let height = (points.end[1] - points.start[1]) ?? 0
        let xStart = width > 0 ? 0 : -width
        let yStart = height > 0 ? 0 : -height

        if (!xStart) {
            xStart = 0
        }

        if (!yStart) {
            yStart = 0
        }
        if (!height) {
            height = 0
        }
        if (!width) {
            width = 0
        }

        // let curveX = 90
        // let curveY = 10

        let halfWidth = width
        let halfHeight = height

        // if (Math.abs(width) < 90) {
        //     curveX = width
        //     curveY = 0
        // }

        // if (Math.abs(height) < 10) {
        //     curveY = height
        //     curveX = 0
        // }

        // if (height === 0 || height === 1) {
        //     height = 2
        // }

        if (halfHeight > 2) {
            halfHeight = height / 2
        }

        if (halfWidth > 2) {
            halfWidth = width / 2
        }

        // height = height - 2


        // console.log(xStart)
        // console.log(yStart)
        let d = 'M ' + xStart + ' ' + yStart + '' + ', ' + (width + xStart) + ', ' + (height + yStart) + ' ' + (width + xStart) + ' ' + (height + yStart)



        let startCor = xStart + ' ,' + yStart
        if (!height) {
            height = 0
        }

        let arrowt = 'matrix(-1,0,0,-1,' + (width + xStart + (this.props.arrowXOffest ?? 0)) + ',' + (height) + ')'


        if (height > 2) {

            // d =
            //     'M ' + xStart + ' ,' + yStart + ', ' +
            //     "L "+(width / 2 + xStart) + ' ,' + yStart + ', ' +
            //     'S '+(width / 2 + xStart) + ' ,' + yStart+ ', ' +((width / 2)+ xStart + 10) + ',' + yStart + 10 + ' , '+
            //     // 'A 10 10 26 0 1' + ((width / 2) + xStart + 10) + ' ' + yStart + 10 + ' , ' +
            //     // ((width / 2) + xStart+10)+' '+yStart+10 +', '+
            //     // 'M '+((width / 2) + xStart+10)+' '+yStart+10 +', '+
            //     (width / 2 + xStart) + ', ' + height + ',' +
            //     (width + xStart) + ' ,' + (height + yStart)



            d =
                // 'M ' + startCor + ', ' +
                // "L " + (width / 2 + xStart) + ', ' +yStart+' , '+

                // "S " + ((width / 2 + xStart)+2 ) + ', ' + (yStart) + ' , ' + ((width / 2 + xStart) + 2) + ', ' + (yStart + 2) + ' , ' +

                // "L " + ((width / 2 + xStart) + 2) + ', ' + height + ' , ' +
                // "S " + ((width / 2 + xStart) + 2) + ', ' + (height + 2) + ' , ' + ((width / 2 + xStart) + 4) + ', ' + (height + 4) + ' , ' +
                // "L " + (width + xStart) + ', ' + (height + 4) + ' , ' +
                // "S " + (width + xStart) + ', ' + (height + 4) + ' , ' + (width + xStart) + ', ' + (height + 4) + ' , '



                'M ' + startCor + ', ' +
                "L " + ((width / 2 + xStart) - 4) + ', ' + yStart + ' , ' +
                "S " + ((width / 2 + xStart) - 2) + ' , ' + (yStart) + ' , ' + ((width / 2 + xStart) - 2) + ', ' + (yStart + 2) + ' , ' +

                "L " + ((width / 2 + xStart) - 2) + ', ' + (height - 2) + ' , ' +
                "S " + ((width / 2 + xStart) - 2) + ', ' + (height) + ' , ' + ((width / 2 + xStart)) + ', ' + (height) + ' , ' +
                "L " + (width + xStart - 2) + ', ' + (height) + ' , ' +
                "S " + (width + xStart) + ', ' + (height) + ' , ' + (width + xStart) + ', ' + (height) + ' , '


            // 'A 10 10 26 0 1' + ((width / 2) + xStart + 10) + ' ' + yStart + 10 + ' , ' +
            // ((width / 2) + xStart+10)+' '+yStart+10 +', '+
            // 'M '+((width / 2) + xStart+10)+' '+yStart+10 +', '+
            // (width / 2 + xStart) + ', ' + height + ',' +
            // (width + xStart) + ' ,' + (height + yStart)

        }

        if (height < -2) {

            d =

                'M ' + startCor + ', ' +
                "L " + ((width / 2 + xStart) - 4) + ', ' + yStart + ' , ' +
                "S " + ((width / 2 + xStart) - 2) + ' , ' + (yStart) + ' , ' + ((width / 2 + xStart) - 2) + ', ' + (yStart - 2) + ' , ' +

                "L " + ((width / 2 + xStart) - 2) + ', ' + (yStart + height + 2) + ' , ' +
                "S " + ((width / 2 + xStart) - 2) + ', ' + (yStart + height) + ' , ' + ((width / 2 + xStart)) + ', ' + (yStart + height) + ' , ' +
                "L " + (width + xStart - 2) + ', ' + (yStart + height) + ' , ' +
                "S " + (width + xStart) + ', ' + (yStart + height) + ' , ' + (width + xStart) + ', ' + (yStart + height) + ' , '

            arrowt = 'matrix(-1,0,0,-1,' + (width + xStart + (this.props.arrowXOffest ?? 0)) + ',' + (yStart + height) + ')'

            // 'M ' + xStart + ' ' + yStart + ' ' +
            // (width / 2 + xStart) + ' ' + yStart + ' ' +
            // (width / 2 + xStart) + ' ' + (yStart + height) + ' ' +
            // (width + xStart) + ' ' + (height + yStart)

        }


        // console.log(yStart)
        // console.log(height)

        // console.log(arrowt)

        // d= '
        //Mq,0 Lq,0 Sq,0,q,0      
        //L292.60350799560547,0 
        //S294.60350799560547,0,294.60350799560547,2 

        //L294.60350799560547,206.8718192577362 

        //S294.60350799560547,208.8718192577362,296.60350799560547,208.8718192577362    
        //L368.20703125, 208.8718192577362  
        //S368.20703125, 208.8718192577362, 368.20703125,208.8718192577362'
        if (height < 2 && height > -2) {
            height = 2
        }

        return (
            <>
                <svg onDrop={this.onDrop} onDragOver={(e) => this.onDragOver(e)} onDragEnter={this.onDragEnter} onDragLeave={this.onDragLeave} id={"id-" + this.props.data.id} height={Math.abs(height)} width={Math.abs(width)} style={{ zIndex: this.props.zIndex ?? (this.state.hovered ? 1 : null), position: 'absolute', top: points.start[1] - yStart, left: points.start[0] - xStart, overflow: 'visible', pointerEvents: 'none' }}>
                    {/* <path d="M0 0 L75 200 L225 200 S 270,200 270,250 L270 300 " fill="none" stroke="blue" stroke-width="3" /> */}
                    {/* <path d="M0 0 L75 200 L225 200 C260,200  270,200 270,220 L270 300" fill="none" stroke="blue" stroke-width="3" /> */}
                    {/* {height > 40  && (
                    <path d={
                        'M3 3 L ' + (width / 2 - 20) + ' 3 C ' + (width / 2 - 10) + ',3  ' + width / 2 + ',3 ' + width / 2 + ',20 L' + width / 2 + ' ' + (height - 20) +
                        ' C ' + (width / 2) + ',' + (height - 10) + '  ' + width / 2 + ',' + (height - 3) + ' ' + (width / 2 + 20) + ',' + (height - 3) + ' L' + width + ' ' + (height - 3)
                    }

                        fill="none" stroke="blue" stroke-width="3" />
                )} */}

                    {/* <path d={
                         'M3 3  C ' + (width / 2) + ', 0 '  +(width / 2) + ', '+(height) +' ' + (width-3) + ' ' + (height-3) 
                     } */}

                    {/* {(height > 40) && ( */}


                    <path d={d}

                        strokeLinejoin="round"
                        // stroke-linejoin="round"
                        // stroke-linecap='round'
                        strokeLinecap='round'


                        // <path d={
                        //     'M ' + xStart + ' ' + yStart + '' +
                        //     'C ' + (xStart + curveX) + ' ' + (yStart + curveY) + ', ' + (width + xStart - curveX) + ', ' + (height + yStart - curveY) + ' ' + (width + xStart) + ' ' + (height + yStart)
                        // }

                        onMouseEnter={(e) => this.mouseHover(e)}
                        onMouseLeave={(e) => this.mouseLeave(e)}
                        onClick={(e) => this.mouseHover(e, true)}

                        fill="none" stroke="transparent" strokeWidth="30" pointerEvents="visibleStroke" />

                    <path d={d}
                        strokeLinejoin="round"
                        // stroke-linejoin="round"
                        // stroke-linecap='round'
                        strokeLinecap='round'

                        fill="none" stroke={this.state.hovered ? "#007aff" : (this.props.pathColor ?? "#666")} strokeWidth="1.5" style={{ transition: 'stroke 0.5s' }} />

                    {!this.props.isActivePath && (
                        <path style={{ pointerEvents: 'none', transition: 'stroke 0.5s' }} pointerEvents="none" fill="#ffffff" stroke={this.state.hovered ? "#007aff" : (this.props.pathColor ?? "#666")} d="M5,5L0,0L5,-5L0,0" strokeWidth="1.5" transform={arrowt}></path>
                    )}
                </svg>


                {/* <svg height={Math.abs(height)} width={Math.abs(width)} style={{ position: 'absolute',  top: points.start[1] - yStart, left: points.start[0] - xStart, overflow: 'visible', pointerEvents: 'none' }}>

                    </svg> */}


                {!this.props.hideCut && (
                    <div
                        onMouseEnter={(e) => this.mouseHover(e)}
                        onMouseLeave={(e) => this.mouseLeave(e)}
                        onClick={() => { if (this.removePath) this.removePath() }}
                        className={"flexcc pathRemoveBut  " + (this.state.hovered ? 'hovered' : '')}
                        style={{ top: points.start[1] - yStart + Math.abs(height) / 2, left: points.start[0] - xStart + Math.abs(width) / 2, zIndex: 1 }}>

                        <img className="invert" src="/images/cut.svg" width="22px" />
                    </div>
                )}

                {this.state.showDrop && (

                    <div

                        className={"flexcc position-absolute  "}
                        style={{ pointerEvents: 'none', top: (points.start[1] - yStart + Math.abs(height) / 2) + 2, left: (points.start[0] - xStart + Math.abs(width) / 2) - 22, zIndex: 1 }}>

                        <div className="br-10 flexcc" style={{ color: '#fff', height: 16, width: 16, backgroundColor: '#007aff', borderRadius: 10 }}>
                            <p>+</p>
                        </div>
                    </div>
                )}
            </>
        )
    }
}



export default DiagramPath;
